<ng-container *ngIf="HasRequiredPermissions">
  <div class="bg-white p-6 my-8 rounded-lg shadow w-full max-w-none">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ 'entities.visit.pluralName' | translate }} ({{ totalSeen }}/{{ listView()?.entities()?.total }})
      </h1>
    </div>

    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
      [ShowRangeDateFilter]="true"
      [fuseauxParSite]="fuseauxParSite"
      [pagination]="{
                      enabled: true,
                      pageLengths: [5, 10, 20, 50, 100, 300],
                      defaultPageLength: 5,
                      searchColumns: ['company', 'visitId', 'visitor.fullname'],
                      sortableColumns: null
                    }"
      [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">

      <div slot="custom-filters" class="px-6 py-2">
        <app-multi-criteria-filter [options]="filterOptions()"
          [multiSelect]="true"
          (selectionChange)="onFilterSelectionChange($event)"
          clearButtonLabel="clearFilters">
        </app-multi-criteria-filter>
      </div>

      <!-- Colonne Photo -->
      <app-list-table-column key="imagePhoto.thumbnail_Path"
        title="{{ 'photo' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <div class="w-12 h-12 bg-gray-100 rounded-[4px] flex items-center justify-center overflow-hidden border border-[3px] border-gray-200 shadow-lg">
            @if (entity.imagePhoto?.thumbnail_Path) {
            <img [src]="rootUrl + entity.imagePhoto.thumbnail_Path" alt="Visitor Photo" class="w-full h-full object-contain">
            } @else {
            <img src="/assets/images/user-regular.svg" alt="Visitor Photo" class="w-full h-full object-contain">
            }
          </div>
        </ng-template>
      </app-list-table-column>

      <!-- Colonne ID (visitId) -->
      <app-list-table-column key="visitId"
        title="{{ 'entities.visit.propreties.visitId' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>

      <!-- Colonne Visitor -->
      <app-list-table-column key="visitor.fullname"
        title="{{ 'entities.visit.propreties.visitor' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>

      <!-- Colonne Company -->
      <app-list-table-column key="company"
        title="{{ 'entities.visit.propreties.company' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>

      <!-- Colonne StartDate -->
      <app-list-table-column key="startDate"
        title="{{ 'entities.visit.propreties.startDate' | translate }}"
        type="datetime"
        [sortable]="true"
        align="left">
      </app-list-table-column>

      <!-- Colonne EndDate -->
      <app-list-table-column key="endDate"
        title="{{ 'entities.visit.propreties.endDate' | translate }}"
        type="custom"
        [sortable]="true"
        align="left">
        <ng-template #endDateTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.endDate) {
            @if (isSameDay(entity.startDate, entity.endDate )) {
            <span class="text-gray-700">{{ getFormatedTimeValue(entity.endDate) }}</span>
            }
            @else {
            <span class="text-gray-700">{{getFormatedDateValue(entity.endDate)}}</span>
            }
            @if (fuseauDeLigne(entity); as iana) {
            <app-timezone-icon [iana]="iana"></app-timezone-icon>
            }
            }
          </div>
        </ng-template>
      </app-list-table-column>

      <!-- Colonne VisitedPerson (employee.fullName) -->
      <app-list-table-column key="employee.fullName"
        title="{{ 'entities.visit.propreties.visitedPerson' | translate }}"
        type="text"
        [sortable]="true"
        align="left">
      </app-list-table-column>

      <!-- Colonne Status -->
      <app-list-table-column key="status"
        title="{{ 'entities.visit.propreties.status' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)"
            [lookupData]="visitStatusLookup()"
            [Skin]="Skin"
            [isEditMode]="true"
            (statusChange)="updateEntityProperty(entity, 'status', $event)">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>

      <!-- Colonne Suggestion (action personnalisée) -->
      <app-list-table-column key="suggestion"
        title="{{ 'vues.visit.list.columns.suggestion' | translate }}"
        type="custom"
        visible="lg">
        <ng-template #customTemplate let-entity>

          <div *ngIf="(entity?.feedbacks && entity?.feedbacks.length>0)" class="relative w-16 h-11"
            [class.-top-3]="!!getFeedBack(entity).comment"
            [class.top-0]="!getFeedBack(entity).comment"
            [class.left-3]="!getFeedBack(entity).comment">
            <app-bubble-smiley class="absolute -top-3 left-0"
              [score]="getFeedBack(entity).score"
              [showAsBubble]="!!getFeedBack(entity).comment"
              [comment]="getFeedBack(entity).comment??''"
              [showCommentInTooltip]="true"
              [size]="!!getFeedBack(entity).comment ?'w-[70px] h-[70px]' : 'w-[45px] h-[45px]'">
            </app-bubble-smiley>
          </div>


        </ng-template>
      </app-list-table-column>

      <!-- Colonne Cartes (attachedCards) -->
      <app-list-table-column key="attachedCards"
        title="{{ 'entities.visit.propreties.card' | translate }}"
        type="custom"
        [sortable]="false"
        align="left">
        <ng-template #customTemplate let-entity>
          <div class="relative inline-block"
            (mouseenter)="showTooltip(entity, true)"
            (mouseleave)="showTooltip(entity, false)">

            @if (entity.attachedCards && entity.attachedCards.trim() !== '') {
            @let cardIds = getCardIds(entity);
            @let nbCards = cardIds.length;

            @if (nbCards === 1) {
            <span class="inline-flex items-center gap-1">
              <i class="fa-solid fa-id-card text-gray-500 text-2xl"></i>
              <span class="text-sm text-gray-700 px-2 py-0.5 bg-gray-100 rounded border border-gray-300">
                {{ cardIds[0] }}
              </span>
            </span>
            } @else {
            <span class="inline-flex items-center gap-1">
              <span class="text-gray-600 text-sm">{{ nbCards }}</span>
              <i class="fa-solid fa-id-card text-gray-500 text-2xl"></i>
            </span>
            }

            @if (hasMultipleCards(entity) && isTooltipVisible(entity)) {
            <div class="absolute z-10 bg-white border border-gray-300 rounded shadow-lg p-2 min-w-[150px] top-full left-0 mt-1">
              @for (id of cardIds; track id) {
              <span class="text-sm text-gray-700 px-2 py-0.5 bg-gray-100 rounded border border-gray-300 block mb-1 last:mb-0">
                {{ id }}
              </span>
              }
            </div>
            }
            }
          </div>
        </ng-template>
      </app-list-table-column>


      <!-- Attachments Column -->
      <app-list-table-column key="agreements" title="{{ 'entities.visit.propreties.agreements' | translate }}" type="custom" visible="lg">
        <ng-template #customTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.fK_PolicyPdf) {
            <i class="fas fa-file-alt text-red-500 text-2xl hover:text-2xl cursor-pointer" title="Agreements" (click)="downloadAgreements(entity)"></i>
            }
            @if (entity.fK_Image_Agreements) {
            <i class="fas fa-file-alt text-red-500 text-2xl hover:text-2xl cursor-pointer" title="Agreements" (click)="downloadOldAgreements(entity)"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <app-list-table-column key="engagements" title="{{ 'entities.visit.propreties.engagements' | translate }}" type="custom" visible="lg">
        <ng-template #customTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.fK_Image_Engagement) {
            <i class="fas fa-file-alt text-red-500 text-2xl hover:text-2xl cursor-pointer" title="Engagements" (click)="downloadEngagements(entity)"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <app-list-table-column key="healthy" title="{{ 'entities.visit.propreties.healthy' | translate }}" type="custom" visible="lg">
        <ng-template #customTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.fK_Image_Covid) {
            <i class="fas fa-file-alt text-red-500 text-2xl hover:text-2xl cursor-pointer" title="Healthy" (click)="downloadhealthy(entity)"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>
      <app-list-table-column key="quiz" title="{{ 'entities.visit.propreties.quiz' | translate }}" type="custom" visible="lg">
        <ng-template #customTemplate let-entity>
          <div class="flex space-x-2">
            @if (entity.fK_Image_Quiz) {
            <i class="fas fa-file-alt text-red-500 text-2xl hover:text-2xl cursor-pointer" title="quiz" (click)="downloadQuiz(entity)"></i>
            }
          </div>
        </ng-template>
      </app-list-table-column>

      <!-- Actions de liste : export Excel, avec sous-menu pour l'export avec documents -->
      <div slot="list-actions" class="relative inline-flex">
        <button (click)="exportVisits(false)" [disabled]="isExporting()" data-testid="list-export"
          class="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 text-sm font-medium border border-gray-200 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300">
          <i class="fa-solid" [class.fa-file-excel]="!isExporting()" [class.fa-spinner]="isExporting()" [class.fa-spin]="isExporting()"></i>
          {{ 'entities.visit.propreties.export' | translate }}
        </button>
        <button (click)="exportMenuOpen.set(!exportMenuOpen())" [disabled]="isExporting()" data-testid="list-export-menu"
          class="bg-teal-500 hover:bg-teal-600 text-white px-2 py-2 text-sm font-medium border border-gray-200 border-l border-l-teal-400 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300">
          <i class="fa-solid fa-chevron-down"></i>
        </button>
        @if (exportMenuOpen()) {
        <div class="fixed inset-0 z-40" (click)="exportMenuOpen.set(false)"></div>
        <div class="absolute left-0 top-full mt-1 z-50 bg-white border border-gray-200 rounded-md shadow-lg min-w-[230px]">
          <button (click)="exportVisits(true)" data-testid="list-export-with-docs"
            class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
            <i class="fa-solid fa-file-zipper"></i>
            {{ 'entities.visit.propreties.exportWithDocs' | translate }}
          </button>
        </div>
        }
      </div>

      <!-- Action de liste : "Date de sortie" — passe a "Out" toutes les visites "In" affichees -->
      <button slot="list-actions" (click)="checkoutAllVisits()" [disabled]="isCheckingOut()" data-testid="list-checkout-all"
        class="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 text-sm font-medium border border-gray-200 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300">
        <i class="fa-solid" [class.fa-right-from-bracket]="!isCheckingOut()" [class.fa-spinner]="isCheckingOut()" [class.fa-spin]="isCheckingOut()"></i>
        {{ 'entities.visit.propreties.exitDate' | translate }}
      </button>

      <!-- Action de liste : "Alerter" — alerte d'evacuation, visible si activee sur le site -->
      @if (fireAlertEnabled) {
      <button slot="list-actions" (click)="sendFireAlert()" [disabled]="isAlerting()" data-testid="list-fire-alert"
        class="bg-red-500 hover:bg-red-600 text-white px-4 py-2 text-sm font-medium border border-gray-200 focus:outline-none disabled:bg-gray-300 disabled:cursor-not-allowed disabled:hover:bg-gray-300">
        <i class="fa-solid" [class.fa-person-running]="!isAlerting()" [class.fa-spinner]="isAlerting()" [class.fa-spin]="isAlerting()"></i>
        {{ 'entities.visit.propreties.alert' | translate }}
      </button>
      }
    </app-list-view>

    <!-- Vue de détail -->
    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white rounded-lg shadow-xl p-1 h-full">
        <app-visit-detail #visitDetail
          [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="onItemUpdated($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()">
        </app-visit-detail>
      </div>
    </div>

  </div>
</ng-container>